const selectorsTab = {
  TAB_TITLE_SELECTOR: '.js-tab-switch-title',
  TAB_CONTENT_SELECTOR: '.js-tab-switch-content',
  TAB_TITLE_ACTIVE_CLASS: 'tab-switch__title--active',
  TAB_CONTENT_ACTIVE_CLASS: 'tab-switch__content--active'
}

class TabSwitch extends HTMLElement {
  constructor() {
    super()

    this.tabTitleEls = this.querySelectorAll(selectorsTab.TAB_TITLE_SELECTOR)
    this.tabContentEls = this.querySelectorAll(selectorsTab.TAB_CONTENT_SELECTOR)
  }

  connectedCallback() {
    if (this.tabTitleEls.length > 0) {
      this.tabTitleEls.forEach((tabTitle) => {
        tabTitle.addEventListener('click', () => {
          const dataIndex = tabTitle.dataset.index
          const tabContent = this.querySelector(`.js-tab-switch-content[data-index='${dataIndex}']`)

          this.tabTitleEls.length > 0 && this.removeClassActive(this.tabTitleEls, selectorsTab.TAB_TITLE_ACTIVE_CLASS)
          this.tabContentEls.length > 0 &&  this.removeClassActive(this.tabContentEls, selectorsTab.TAB_CONTENT_ACTIVE_CLASS)
          tabTitle.classList.add(selectorsTab.TAB_TITLE_ACTIVE_CLASS)
          tabContent && tabContent.classList.add(selectorsTab.TAB_CONTENT_ACTIVE_CLASS)
        })
      });
    }
  }

  removeClassActive(items, classActive) {
    if (!items.length) return
    items.forEach((item) => {
      item.classList.remove(classActive)
    });
  }
}

if (!customElements.get('tab-switch')) {
  customElements.define('tab-switch', TabSwitch)
}